const helpers = window.BASE_HELPERS || {};
const { YouTubePlayer } = helpers;

const MODULE = document.querySelectorAll('[data-module="texto_imagem_video"]');

class TextoImagemVideo {
    constructor() {
        this.components = MODULE;
        this.init();
    }

    async init() {
        for (const component of this.components) {

            const videoElement = component.querySelector('[data-youtube-id]');
            const buttonVideoPlay = component.querySelector('[data-video-play]')

            if (!videoElement) continue;

            const videoId = videoElement.dataset.youtubeId;
            const elementId = videoElement.id || `yt-${videoId}`;

            await YouTubePlayer.mount({
                videoId,
                elementId,
                playerVars: {
                    controls: 1,
                    muted: false
                },
                onStateChange: (event) => {
                    switch (event.data) {
                        case YT.PlayerState.PLAYING:
                            YouTubePlayer.pauseOthers(elementId);
                            component.querySelector(`#${elementId}`).classList.add('is-playing');
                            break;
                        case YT.PlayerState.PAUSED:
                            component.querySelector(`#${elementId}`).classList.remove('is-playing');
                            break;
                        case YT.PlayerState.ENDED:
                            break;
                    }
                },
            });

            buttonVideoPlay.addEventListener('click', () => {
                YouTubePlayer.play(videoElement, { muted: false })
            });
        }
    }
}

(() => {
    if (MODULE.length) {
        new TextoImagemVideo();
    }
})();

export default TextoImagemVideo;
